import { Container } from './styles';
import Lottie from 'lottie-react';
import JsonLoading from "../../Assets/json/loader.json";

const CustonLoading = ({size}) => {
    return (
        <Container>
            <Lottie animationData={JsonLoading} loop={true} style={{ width: size, height: size }} />
            {/* <Loader $size={size} $color={color}/> */}
        </Container>
    );
}

export default CustonLoading;